
import mutations from './mutation.js'
import actions from './actions.js'
import state from './state.js'


export default {
	namespaced: true,
    state:state,
    mutations: mutations,
    actions: actions,
}